export class TaxApiParam {

    public mint_refid: number;
    public mintOfficeID: number;
    public mintStateid: number;
    public mintProductSegmentId: number;
    public mintBillSegmentId: number;
    public mintFormId: number;
    public dtBillDate: string;
    public xmlData: string;
    public mstrInvoiceType: string;
    public flag: number;
    public StateFromId: number;
    public StateToId: number;
    public TransactionId: number;
    public BillingID: number;
    public MachinieGroupID: number;
    constructor() {
        this.mint_refid = 0;
        this.mintOfficeID = 0;
        this.mintStateid = 0;
        this.mintProductSegmentId = 0;
        this.mintBillSegmentId = 0;
        this.mintFormId = 0;
        this.dtBillDate = "";
        this.xmlData = "";
        this.mstrInvoiceType = "T";
        this.flag = 0;
        this.StateFromId = 0;
        this.StateToId = 0;
        this.TransactionId = 0;
        this.BillingID = 0;
        this.MachinieGroupID = 0;
    }

}